import { queryClient } from '@/queryClient.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as Sentry from '@sentry/vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import VueDndKitPlugin from '@vue-dnd-kit/core'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ConfirmationService from 'primevue/confirmationservice'
import KeyFilter from 'primevue/keyfilter'
import ToastService from 'primevue/toastservice'
import Tooltip from 'primevue/tooltip'
import GoogleSignInPlugin from 'vue3-google-signin'
import { RouterLink } from 'vue-router'

import { createApp, h } from 'vue'
import { defineComponent } from 'vue'

import { i18n } from '@/features/i18n/i18n.js'
import ClubRouterLink from '@/features/router/ClubRouterLink.vue'
import { router } from '@/features/router/router.js'
import { setupFieldPlugins } from '@/features/settingsManagement/fieldManagement/edit/plugin/fieldsPlugin.js'
import { FMPreset } from '@/features/theme/config.js'

import App from './App.vue'
import './style.scss'

// FontAwesome - add all icons to library
library.add(fas, far, fab)

export default defineComponent({
  components: { ClubRouterLink },
})

const app = createApp(App)

export function commonAppSetup(app) {
  Sentry.init({
    app,
    dsn: 'https://626f0f8680384dccba002eaf264ddb06@o496761.ingest.us.sentry.io/4509475777544192',
    sendDefaultPii: true,
    integrations: [],
    environment: import.meta.env.MODE,
  })

  // Primevue setup
  app.use(PrimeVue, {
    theme: {
      preset: FMPreset,
      options: {
        prefix: 'p',
        darkModeSelector: '.fm-dark',
        cssLayer: {
          name: 'primevue',
          order: 'tailwind-base, primevue, tailwind-utilities',
        },
      },
    },
  })

  app.use(ToastService)
  app.use(ConfirmationService)
  app.directive('tooltip', Tooltip)
  app.directive('keyfilter', KeyFilter)

  // Pinia setup
  app.use(createPinia())

  // i18n setup
  app.use(i18n)

  // DnD setup
  app.use(VueDndKitPlugin)

  // Router setup
  app.use(router)

  // Google sign in setup
  app.use(GoogleSignInPlugin, {
    clientId: '469668551712-br85eka1n0i2di5i7ndo699kn8am4h9g.apps.googleusercontent.com',
  })

  // Vue Query setup
  app.use(VueQueryPlugin, {
    queryClient,
  })

  // dynamic fields setup
  setupFieldPlugins()

  app.component('RouterLink', {
    props: RouterLink.props,
    setup(props, { slots }) {
      return () => h(ClubRouterLink, props, slots)
    },
  })

  // FontAwesome global component
  app.component('font-awesome-icon', FontAwesomeIcon)

  return app
}

commonAppSetup(app)
app.mount('#app')
